const TABS = ["View Application", "Documents", "Timeline"];

export default function TopTabs({ activeTab, setActiveTab }) {
  return (
    <div className="flex gap-3 mb-6">
      {TABS.map((tab) => (
        <button
          key={tab}
          onClick={() => setActiveTab(tab)}
          className={`px-5 py-2 rounded-full text-sm font-medium border transition
            ${
              activeTab === tab
                ? "bg-[#5B2D8B] text-white border-[#5B2D8B]"
                : "bg-white text-[#5B2D8B] border-[#D7C6E5]"
            }`}
        >
          {tab}
        </button>
      ))}
    </div>
  );
}
